import { Product } from '../../types';

export const batteryTerminalsProducts: Product[] = [
  {
    id: "bt-battery-sbt011401",
    name: "Brass Battery Terminal - 11mm CUT Type (SBT011401)",
    slug: "brass-battery-terminal-11mm-cut-type-sbt011401",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "11mm CUT type brass battery terminal with distinctive cut-out design. Suitable for standard automotive battery connections.",
    partNumber: "SBT011401",
    specifications: {
      "Size": "11mm",
      "Type": "CUT Type",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011401.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "11mm", "cut-type"],
    applications: ["Automotive", "Battery Connections"],
  },
  {
    id: "bt-battery-sbt011404",
    name: "Brass Battery Terminal - 11mm 2 Bolt Medium Duty (SBT011404)",
    slug: "brass-battery-terminal-11mm-2-bolt-medium-duty-sbt011404",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "11mm brass battery terminal with 2-bolt design for medium-duty applications. Secure connection with dual bolt fastening.",
    partNumber: "SBT011404",
    specifications: {
      "Size": "11mm",
      "Bolts": "2",
      "Duty": "Medium Duty",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011404.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "11mm", "2-bolt", "medium-duty"],
    applications: ["Automotive", "Battery Connections"],
  },
  {
    id: "bt-battery-sbt011406",
    name: "Brass Battery Terminal - 11mm 2 Bolt Heavy Duty (SBT011406)",
    slug: "brass-battery-terminal-11mm-2-bolt-heavy-duty-sbt011406",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "11mm brass battery terminal with robust 2-bolt design for heavy-duty applications. Enhanced construction for high-current applications.",
    partNumber: "SBT011406",
    specifications: {
      "Size": "11mm",
      "Bolts": "2",
      "Duty": "Heavy Duty",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011406.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "11mm", "2-bolt", "heavy-duty"],
    applications: ["Automotive", "Battery Connections", "Heavy Duty"],
  },
  {
    id: "bt-battery-sbt011408",
    name: "Brass Battery Terminal - 12mm 2 Bolt (SBT011408)",
    slug: "brass-battery-terminal-12mm-2-bolt-sbt011408",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "12mm brass battery terminal with 2-bolt connection for secure fastening. Suitable for standard battery posts.",
    partNumber: "SBT011408",
    specifications: {
      "Size": "12mm",
      "Bolts": "2",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011408.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "12mm", "2-bolt"],
    applications: ["Automotive", "Battery Connections"],
  },
  {
    id: "bt-battery-sbt011410",
    name: "Brass Battery Terminal - 13mm 2 Bolt (SBT011410)",
    slug: "brass-battery-terminal-13mm-2-bolt-sbt011410",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "13mm brass battery terminal with 2-bolt design for reliable electrical connections. High conductivity brass construction.",
    partNumber: "SBT011410",
    specifications: {
      "Size": "13mm",
      "Bolts": "2",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011410.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "13mm", "2-bolt"],
    applications: ["Automotive", "Battery Connections"],
  },
  {
    id: "bt-battery-sbt011413",
    name: "Brass Battery Terminal - 14mm 2 Bolt (SBT011413)",
    slug: "brass-battery-terminal-14mm-2-bolt-sbt011413",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "14mm brass battery terminal with 2-bolt design for strong and stable connections. Enhanced reliability.",
    partNumber: "SBT011413",
    specifications: {
      "Size": "14mm",
      "Bolts": "2",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011413.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "14mm", "2-bolt"],
    applications: ["Automotive", "Battery Connections"],
  },
  {
    id: "bt-battery-sbt011415",
    name: "Brass Battery Terminal - 20mm 2 Bolt Heavy Duty (SBT011415)",
    slug: "brass-battery-terminal-20mm-2-bolt-heavy-duty-sbt011415",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "20mm heavy-duty battery terminal with silver finish and 2-bolt design. Robust construction for high-current applications.",
    partNumber: "SBT011415",
    specifications: {
      "Size": "20mm",
      "Bolts": "2",
      "Duty": "Heavy Duty",
      "Material": "CuZn-63/37",
      "Finish": "Silver",
      "Standard Packing": "12 Pcs. Packet",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011415.jpg"],
    tags: ["terminal", "battery", "heavy-duty", "automotive", "20mm", "2-bolt", "silver-finish"],
    applications: ["Automotive", "Battery Connections", "High Current"],
  },
  {
    id: "bt-battery-sbt011420",
    name: "Brass Battery Terminal - Telco Type (SBT011420)",
    slug: "brass-battery-terminal-telco-type-sbt011420",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Telco type brass battery terminal with distinct curved design and single bolt connection. Designed for Telco vehicle applications.",
    partNumber: "SBT011420",
    specifications: {
      "Type": "Telco Type",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011420.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "telco-type"],
    applications: ["Automotive", "Battery Connections", "Telco Vehicles"],
  },
  {
    id: "bt-battery-sbt011421",
    name: "Brass Battery Terminal - TVS Type (SBT011421)",
    slug: "brass-battery-terminal-tvs-type-sbt011421",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "TVS type brass battery terminal designed for specific TVS vehicle applications. Single bolt connection mechanism.",
    partNumber: "SBT011421",
    specifications: {
      "Type": "TVS Type",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011421.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "tvs-type"],
    applications: ["Automotive", "Battery Connections", "TVS Vehicles"],
  },
  {
    id: "bt-battery-sbt011423",
    name: "Brass Battery Terminal - Maruti Type 2 Bolt Heavy Duty (SBT011423)",
    slug: "brass-battery-terminal-maruti-type-2-bolt-heavy-duty-sbt011423",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Maruti type heavy-duty brass battery terminal with 2-bolt design. Robust construction for Maruti vehicle battery connections.",
    partNumber: "SBT011423",
    specifications: {
      "Type": "Maruti Type",
      "Bolts": "2",
      "Duty": "Heavy Duty",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011423.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "maruti", "2-bolt", "heavy-duty"],
    applications: ["Automotive", "Battery Connections", "Maruti Vehicles"],
  },
  {
    id: "bt-battery-sbt011425",
    name: "Brass Battery Terminal - Maruti Bolt Type Light Duty (SBT011425)",
    slug: "brass-battery-terminal-maruti-bolt-type-light-duty-sbt011425",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Maruti bolt type light-duty brass battery terminal. Simple and effective bolt connection for Maruti vehicles.",
    partNumber: "SBT011425",
    specifications: {
      "Type": "Maruti Bolt Type",
      "Duty": "Light Duty",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011425.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "maruti", "bolt-type", "light-duty"],
    applications: ["Automotive", "Battery Connections", "Maruti Vehicles"],
  },
  {
    id: "bt-battery-sbt011428",
    name: "Brass Battery Terminal - Maruti Screw Type Light Duty (SBT011428)",
    slug: "brass-battery-terminal-maruti-screw-type-light-duty-sbt011428",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Maruti screw type light-duty brass battery terminal. Easy and secure screw-based connection for Maruti vehicles.",
    partNumber: "SBT011428",
    specifications: {
      "Type": "Maruti Screw Type",
      "Duty": "Light Duty",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011428.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "maruti", "screw-type", "light-duty"],
    applications: ["Automotive", "Battery Connections", "Maruti Vehicles"],
  },
  {
    id: "bt-battery-sbt011430",
    name: "Brass Battery Terminal - MST (SBT011430)",
    slug: "brass-battery-terminal-mst-sbt011430",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "MST type battery terminal with silver finish and unique large-head bolt design. Secure fastening for reliable connections.",
    partNumber: "SBT011430",
    specifications: {
      "Type": "MST",
      "Material": "CuZn-63/37",
      "Finish": "Silver",
      "Standard Packing": "12 Pcs. Packet",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011430.jpg"],
    tags: ["terminal", "battery", "automotive", "mst", "silver-finish"],
    applications: ["Automotive", "Battery Connections"],
  },
  {
    id: "bt-battery-sbt011436",
    name: "Brass Battery Terminal - Maruti Angel Type Heavy Duty (SBT011436)",
    slug: "brass-battery-terminal-maruti-angel-type-heavy-duty-sbt011436",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Maruti Angel type heavy-duty brass battery terminal. Robust design for heavy-duty connections in Maruti vehicles.",
    partNumber: "SBT011436",
    specifications: {
      "Type": "Maruti Angel Type",
      "Duty": "Heavy Duty",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011436.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "maruti", "angel-type", "heavy-duty"],
    applications: ["Automotive", "Battery Connections", "Maruti Vehicles"],
  },
  {
    id: "bt-battery-sbt011438",
    name: "Brass Battery Terminal - Maruti Angel Type Light Duty (SBT011438)",
    slug: "brass-battery-terminal-maruti-angel-type-light-duty-sbt011438",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Maruti Angel type light-duty brass battery terminal. Reliable connection for standard Maruti vehicle applications.",
    partNumber: "SBT011438",
    specifications: {
      "Type": "Maruti Angel Type",
      "Duty": "Light Duty",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011438.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "maruti", "angel-type", "light-duty"],
    applications: ["Automotive", "Battery Connections", "Maruti Vehicles"],
  },
  {
    id: "bt-battery-sbt011451",
    name: "Brass Battery Terminal - Angel Type Extra Heavy Duty (SBT011451)",
    slug: "brass-battery-terminal-angel-type-extra-heavy-duty-sbt011451",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Angel type extra heavy-duty brass battery terminal. C-clamp design with flat extension and two cable connection bolts. Maximum robustness.",
    partNumber: "SBT011451",
    specifications: {
      "Type": "Angel Type",
      "Duty": "Extra Heavy Duty",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
      "Design": "C-Clamp with 2 Cable Bolts",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011451.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "angel-type", "extra-heavy-duty"],
    applications: ["Automotive", "Battery Connections", "Extra Heavy Duty"],
  },
  {
    id: "bt-battery-sbt011453",
    name: "Brass Battery Terminal - Angel Type Heavy Duty (SBT011453)",
    slug: "brass-battery-terminal-angel-type-heavy-duty-sbt011453",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Angel type heavy-duty brass battery terminal. C-clamp design with flat extension and two cable connection bolts.",
    partNumber: "SBT011453",
    specifications: {
      "Type": "Angel Type",
      "Duty": "Heavy Duty",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
      "Design": "C-Clamp with 2 Cable Bolts",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011453.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "angel-type", "heavy-duty"],
    applications: ["Automotive", "Battery Connections", "Heavy Duty"],
  },
  {
    id: "bt-battery-sbt011455",
    name: "Brass Battery Terminal - Angel Type Medium Duty (SBT011455)",
    slug: "brass-battery-terminal-angel-type-medium-duty-sbt011455",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Angel type medium-duty brass battery terminal. C-clamp design with flat extension and two cable connection bolts.",
    partNumber: "SBT011455",
    specifications: {
      "Type": "Angel Type",
      "Duty": "Medium Duty",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
      "Design": "C-Clamp with 2 Cable Bolts",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011455.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "angel-type", "medium-duty"],
    applications: ["Automotive", "Battery Connections"],
  },
  {
    id: "bt-battery-sbt011457",
    name: "Brass Battery Terminal - Angel Type (SBT011457)",
    slug: "brass-battery-terminal-angel-type-sbt011457",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Standard Angel type brass battery terminal. C-clamp design with flat extension and two cable connection bolts.",
    partNumber: "SBT011457",
    specifications: {
      "Type": "Angel Type",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
      "Design": "C-Clamp with 2 Cable Bolts",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011457.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "angel-type"],
    applications: ["Automotive", "Battery Connections"],
  },
  {
    id: "bt-battery-sbt011459",
    name: "Brass Battery Terminal - Angel Type Light Duty (SBT011459)",
    slug: "brass-battery-terminal-angel-type-light-duty-sbt011459",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Angel type light-duty brass battery terminal. C-clamp design with flat extension and two cable connection bolts.",
    partNumber: "SBT011459",
    specifications: {
      "Type": "Angel Type",
      "Duty": "Light Duty",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
      "Design": "C-Clamp with 2 Cable Bolts",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011459.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "angel-type", "light-duty"],
    applications: ["Automotive", "Battery Connections"],
  },
  {
    id: "bt-battery-sbt011461",
    name: "Brass Battery Terminal - Angel Type Normal For Tractor (SBT011461)",
    slug: "brass-battery-terminal-angel-type-normal-for-tractor-sbt011461",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Angel type brass battery terminal specifically designed for tractors. Normal duty variant with C-clamp design.",
    partNumber: "SBT011461",
    specifications: {
      "Type": "Angel Type",
      "Duty": "Normal For Tractor",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
      "Design": "C-Clamp with 2 Cable Bolts",
      "Application": "Tractor",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011461.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "angel-type", "tractor"],
    applications: ["Automotive", "Battery Connections", "Tractor"],
  },
  {
    id: "bt-battery-sbt011463",
    name: "Brass Battery Terminal - Angel Type Medium For Tractor (SBT011463)",
    slug: "brass-battery-terminal-angel-type-medium-for-tractor-sbt011463",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Angel type medium-duty brass battery terminal for tractor applications. C-clamp design with enhanced durability.",
    partNumber: "SBT011463",
    specifications: {
      "Type": "Angel Type",
      "Duty": "Medium For Tractor",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
      "Design": "C-Clamp with 2 Cable Bolts",
      "Application": "Tractor",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011463.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "angel-type", "medium-duty", "tractor"],
    applications: ["Automotive", "Battery Connections", "Tractor"],
  },
  {
    id: "bt-battery-sbt011465",
    name: "Brass Battery Terminal - Angel Type Light Duty For Tractor (SBT011465)",
    slug: "brass-battery-terminal-angel-type-light-duty-for-tractor-sbt011465",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Angel type light-duty brass battery terminal for tractor applications. C-clamp design for standard tractor battery connections.",
    partNumber: "SBT011465",
    specifications: {
      "Type": "Angel Type",
      "Duty": "Light Duty For Tractor",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
      "Design": "C-Clamp with 2 Cable Bolts",
      "Application": "Tractor",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011465.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "angel-type", "light-duty", "tractor"],
    applications: ["Automotive", "Battery Connections", "Tractor"],
  },
  {
    id: "bt-battery-sbt011481",
    name: "Brass Battery Terminal - Strip Type Extra Heavy Duty (STP DLX) (SBT011481)",
    slug: "brass-battery-terminal-strip-type-extra-heavy-duty-stp-dlx-sbt011481",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Strip type extra heavy-duty brass battery terminal (STP DLX). Solid upright design with circular opening and single top-mounted bolt.",
    partNumber: "SBT011481",
    specifications: {
      "Type": "Strip Type",
      "Duty": "Extra Heavy Duty",
      "Model": "STP DLX",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
      "Design": "Solid Upright with Single Top Bolt",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011481.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "strip-type", "extra-heavy-duty", "stp-dlx"],
    applications: ["Automotive", "Battery Connections", "Extra Heavy Duty"],
  },
  {
    id: "bt-battery-sbt011483",
    name: "Brass Battery Terminal - Strip Type Medium Duty (STP HD) (SBT011483)",
    slug: "brass-battery-terminal-strip-type-medium-duty-stp-hd-sbt011483",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Strip type medium-duty brass battery terminal (STP HD). Solid upright design with circular opening and single top-mounted bolt.",
    partNumber: "SBT011483",
    specifications: {
      "Type": "Strip Type",
      "Duty": "Medium Duty",
      "Model": "STP HD",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
      "Design": "Solid Upright with Single Top Bolt",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011483.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "strip-type", "medium-duty", "stp-hd"],
    applications: ["Automotive", "Battery Connections"],
  },
  {
    id: "bt-battery-sbt011484",
    name: "Brass Battery Terminal - Strip Type Heavy Duty (STP) (SBT011484)",
    slug: "brass-battery-terminal-strip-type-heavy-duty-stp-sbt011484",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Strip type heavy-duty brass battery terminal (STP). Solid upright design with circular opening and single top-mounted bolt.",
    partNumber: "SBT011484",
    specifications: {
      "Type": "Strip Type",
      "Duty": "Heavy Duty",
      "Model": "STP",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
      "Design": "Solid Upright with Single Top Bolt",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011484.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "strip-type", "heavy-duty", "stp"],
    applications: ["Automotive", "Battery Connections", "Heavy Duty"],
  },
  {
    id: "bt-battery-sbt011485",
    name: "Brass Battery Terminal - Strip Type Extra Medium Duty (STM) (SBT011485)",
    slug: "brass-battery-terminal-strip-type-extra-medium-duty-stm-sbt011485",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Strip type extra medium-duty brass battery terminal (STM). Solid upright design with circular opening and single top-mounted bolt.",
    partNumber: "SBT011485",
    specifications: {
      "Type": "Strip Type",
      "Duty": "Extra Medium Duty",
      "Model": "STM",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
      "Design": "Solid Upright with Single Top Bolt",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011485.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "strip-type", "extra-medium-duty", "stm"],
    applications: ["Automotive", "Battery Connections"],
  },
  {
    id: "bt-battery-sbt011487",
    name: "Brass Battery Terminal - Strip Type Light Duty (STS) (SBT011487)",
    slug: "brass-battery-terminal-strip-type-light-duty-sts-sbt011487",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Strip type light-duty brass battery terminal (STS). Solid upright design with circular opening and single top-mounted bolt.",
    partNumber: "SBT011487",
    specifications: {
      "Type": "Strip Type",
      "Duty": "Light Duty",
      "Model": "STS",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
      "Design": "Solid Upright with Single Top Bolt",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011487.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "strip-type", "light-duty", "sts"],
    applications: ["Automotive", "Battery Connections"],
  },
  {
    id: "bt-battery-sbt011489",
    name: "Brass Battery Terminal - Strip Type Extra Light Duty (STL) (SBT011489)",
    slug: "brass-battery-terminal-strip-type-extra-light-duty-stl-sbt011489",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Strip type extra light-duty brass battery terminal (STL). Solid upright design with circular opening and single top-mounted bolt.",
    partNumber: "SBT011489",
    specifications: {
      "Type": "Strip Type",
      "Duty": "Extra Light Duty",
      "Model": "STL",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
      "Design": "Solid Upright with Single Top Bolt",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011489.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "strip-type", "extra-light-duty", "stl"],
    applications: ["Automotive", "Battery Connections"],
  },
  {
    id: "bt-battery-sbt011492",
    name: "Brass Battery Terminal - Strip Type (STK) (SBT011492)",
    slug: "brass-battery-terminal-strip-type-stk-sbt011492",
    category: "Brass Terminal",
    subcategory: "Battery Terminals",
    description: "Generic strip type brass battery terminal (STK). Solid upright design with circular opening and single top-mounted bolt.",
    partNumber: "SBT011492",
    specifications: {
      "Type": "Strip Type",
      "Model": "STK",
      "Material": "CuZn-63/37",
      "Standard Packing": "12 Pcs. Packet",
      "Design": "Solid Upright with Single Top Bolt",
    },
    images: ["/products/brass-terminals/battery-terminals/SBT011492.jpg"],
    tags: ["terminal", "battery", "brass", "automotive", "strip-type", "stk"],
    applications: ["Automotive", "Battery Connections"],
  },
];
